import EmailIcon from '@mui/icons-material/Email';
import { LoadingButton } from '@mui/lab';
import { Box, Dialog, DialogActions, DialogContent, FormControl, FormControlLabel, Grid, Icon, InputAdornment, Link, Switch } from '@mui/material';
import Keycloak from 'keycloak-js';
import { isArray } from "lodash";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useResetRecoilState, useSetRecoilState } from "recoil";
import { Auth } from "../../Component/Api/Auth/AuthService";
import { IntermediateGlobalLoading } from "../../Component/Common/Components/Loading/IntermediateGlobalLoading";
import { PageLayout } from "../../Component/Common/Container/PageLayout";
import { LoginTypeResponse, ProcessLoginRequest, TokenRequest } from "../../Component/Model/SignIn";
import { ValidateEmailAddress, defaultObject } from "../../Component/Model/helpers";
import { coreTokenAtom, tokenAtom } from "../../State/Token.Atom";
import config from "../../config";
import { CustomDialogTitle } from "../Common/Custom/CustomDialogTitle";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { LoginTextField } from "../../Component/Common/Components/TextField/CustomTextField";
import { ConsolidationAtom } from "../../State/Consolidation.Atom";
import { EEScorecardAtom } from "../../State/EEScorecard.Atom";
import { ScorecardAtom } from "../../State/Scorecard.Atom";
import { VerificationCompanyAtom } from "../../State/VerificationCompany.Atom";
import './login-page.loginPage.css';
import { WSPScorecardAtom } from '../../State/WSPScorecard.Atom';
import { OfoCodeAtom } from '../../State/OfoCode.Atom';
import { OfoCodeService } from '../../Component/Api/OFOCodes/OfoCodeService';
import { OrganisationAtom } from '../../State/Organisation.Atom';
import { BBBEEScorecardAtom } from '../../State/BBBEEScorecard.Atom';
import { UserAtom } from '../../State/user.Atom';
import { AdvisoryService } from '../../Component/Api/Advisory/AdvisoryService';
import { ClientAdvisorAtom } from '../../State/Advisory/ClientAdvisors.Atom';
import { ClientRegistrationAtom } from '../../State/Advisory/ClientRegistration.Atom';

export const LoginPage: React.FC = () => {

    const hrefLink = '#';
    const history = useHistory();
    const [showModal, setShowModal] = React.useState({
        open: false,
        name: '',
    });
    const [loginEmail, setloginEmail] = React.useState("");
    const [forgotEmail, setForgotEmail] = React.useState("");
    const [forgotPassword, setForgotPassword] = React.useState("");
    const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);
    const [isUser, setIsUser] = React.useState(false);
    const [hasMFA, setHasMFA] = React.useState(false);
    const [rememberMe, setRememberMe] = React.useState(false);
    const [loginPassword, setloginPassword] = React.useState("");
    const [mfa, setMFA] = React.useState("");
    const [loginPasswordState, setloginPasswordState] = React.useState("");
    const [forgotEmailState, setForgotEmailState] = React.useState("");
    const [forgotPasswordState, setForgotPasswordState] = React.useState("");
    const [loginEmailState, setloginEmailState] = React.useState("");
    const [MFAState, setMFAState] = React.useState("");
    const [loginType, setLoginType] = React.useState<LoginTypeResponse>(defaultObject);
    const [token, setToken] = useRecoilState<string>(tokenAtom);
    const [coreToken, setCoreToken] = useRecoilState<string>(coreTokenAtom);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isForgotLoading, setIsForgotLoading] = React.useState(false);
    const [pageLoading, setPageLoading] = React.useState(false);
    const setOfoCodes = useSetRecoilState(OfoCodeAtom);
    const setClientAdvisors = useSetRecoilState(ClientAdvisorAtom);
    const resetScorecard = useResetRecoilState(ScorecardAtom);
    const resetScorecardType = useResetRecoilState(ConsolidationAtom);
    const resetScorecardData = useResetRecoilState(EEScorecardAtom);
    const resetVerificationCompany = useResetRecoilState(VerificationCompanyAtom);
    const resetWSPScorecard = useResetRecoilState(WSPScorecardAtom);
    const resetClientRegistration = useResetRecoilState(ClientRegistrationAtom);
    const resetOrganisation = useResetRecoilState(OrganisationAtom);
    const resetBBBEEScorecard = useResetRecoilState(BBBEEScorecardAtom);
    const resetUser = useResetRecoilState(UserAtom);

    const realm = localStorage.getItem('realm');
    const clientId = localStorage.getItem('clientId');


    let initOptions = {
        'url': config.keycloakUrl,
        'realm': realm || 'Development',
        'clientId': clientId || 'bee123'
    };
    let keycloak = new Keycloak(initOptions);


    keycloak.init({ responseMode: "query", checkLoginIframe: false });

    keycloak.onAuthSuccess = () => {
        if (keycloak.token! != null) {
            setCoreToken(keycloak.token);
            const loginParams = {
                loginType: 'redirect',
                tokens: {
                    accessToken: keycloak.token,
                    refreshToken: keycloak.refreshToken,
                }
            }
            const SSOFormData = new URLSearchParams();
            SSOFormData.append('loginType', loginParams.loginType);
            SSOFormData.append('tokens[accessToken]', loginParams.tokens.accessToken);
            SSOFormData.append('tokens[refreshToken]', loginParams.tokens.refreshToken!);
            setPageLoading(true)
            Auth.SSO(SSOFormData).then((res) => {
                if (res.data) {
                    setToken(res.data.access_token);
                    history.push({
                        pathname: '/home',
                        state: {
                            showPopup: true,
                        }
                    });
                }
            }).catch((err) => {
                if (err.response?.status === 403) {
                    toast.error(err.response.data);
                } else {
                    toast.error("Invalid username or password provided.");
                }
            }).finally(() => {
                setPageLoading(false);
            });

        }
    };

    const sendResetPassword = async () => {
        try {
            if (forgotPassword.length < 1) {
                setForgotPasswordState("error");
                toast.error("Please enter a username");
                return;
            }
            setIsForgotLoading(true);
            await Auth.forgotPassword(forgotPassword);
            toast.success("Email sent successfully");
            setShowModal({ name: '', open: false });
            setIsForgotLoading(false);
        } catch (error) {
            console.log(error);
            toast.success("If an account exists for the provided username, we will send you instructions on how to reset your password");
        }
        finally {
            setIsForgotLoading(false);
        }

    }

    const sendUserEmail = async () => {
        try {
            if (!ValidateEmailAddress(forgotEmail)) {
                setForgotEmailState("error");
                toast.error("Invalid email address");
                return;
            }
            setIsForgotLoading(true);
            await Auth.forgotUsername(forgotEmail);
            toast.success("Email sent successfully");
            setShowModal({ name: '', open: false });
        } catch (error) {
            console.log(error);
            toast.success("If an account exists for the provided email address, we will send you instructions on how to reset your password");
        } finally {
            setIsForgotLoading(false);
        }
    }

    const loginClick = async () => {

        setIsLoading(true);
        if (loginEmailState === "error") {
            setIsUser(false);
            setIsLoading(false);
            return;
        }

        try {
            const result = await Auth.getLoginType(loginEmail);
            setLoginType(result.data);
            if (result.data.LoginType === "redirect") {
                localStorage.setItem('realm', result.data.KeycloakRealmName);
                keycloak.realm = result.data.KeycloakRealmName;
                localStorage.setItem('clientId', result.data.KeycloakClientId);
                keycloak.clientId = result.data.KeycloakClientId;

                await keycloak.login({
                    loginHint: loginEmail,
                    idpHint: result.data.KeycloakDefaultIdp,
                    redirectUri: window.location.href,
                })
                return;
            }
            setloginEmailState("success");
            setIsUser(true);
            setIsLoading(false);
            document.getElementById("loginpassword")?.focus();
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            setloginEmailState("error");
            setIsUser(false);
        }

    };

    const loginwithQR = async () => {
        try {
            setIsLoading(true);
            resetAllData();
            if (MFAState === "error") {
                return;
            }
            const tokenRequest: TokenRequest = {
                RememberMe: rememberMe.toString(),
                grant_type: "password",
                username: loginEmail,
                password: loginPassword,
                loginType: loginType.LoginType,
                TwoFactorCode: mfa
            }
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('grant_type', tokenRequest.grant_type);
            bodyFormData.append('username', tokenRequest.username);
            bodyFormData.append('password', tokenRequest.password);
            bodyFormData.append('RememberMe', tokenRequest.RememberMe);
            bodyFormData.append('TwoFactorCode', tokenRequest.TwoFactorCode!);
            const result = await Auth.Token(bodyFormData);
            setToken(result.data.access_token);
            await coreLogin(tokenRequest.username, tokenRequest.password);
            setIsLoading(false);
        } catch (error: any) {
            const errorMessage = error.response?.data.error_description || "User authentication failed.";
            toast.error(errorMessage);
            setIsLoading(false);
        }
    }

    const loginwithPasswordClick = async () => {

        setIsLoading(true);
        resetAllData();
        if (loginPasswordState === "error") {
            setIsLoading(false);
            return;
        }
        const request: ProcessLoginRequest = {
            username: loginEmail,
            password: loginPassword,
            loginType: loginType.LoginType
        }
        try {
            const result = await Auth.ProcessLogin(request);
            setloginEmailState("success");
            setloginPasswordState("success");
            setIsUser(true);
            if (result.data.IsDirectLogin) {
                setRememberMe(false);
                const secondRequest: TokenRequest = {
                    RememberMe: rememberMe.toString(),
                    grant_type: "password",
                    username: loginEmail,
                    password: loginPassword,
                    loginType: loginType.LoginType
                }
                const bodyFormData = new URLSearchParams();
                bodyFormData.append('grant_type', secondRequest.grant_type);
                bodyFormData.append('username', secondRequest.username);
                bodyFormData.append('password', secondRequest.password);
                bodyFormData.append('RememberMe', secondRequest.RememberMe);
                const token = await Auth.Token(bodyFormData);
                setToken(token.data.access_token);
                await coreLogin(secondRequest.username, secondRequest.password);
            }
            if (!result.data.IsTwoFactorAuthenticationConfigured && !result.data.IsDirectLogin) {
                history.push({
                    pathname: `/twoFactorAuthentication`,
                    state: {
                        RememberMe: rememberMe.toString(),
                        grant_type: "password",
                        username: loginEmail,
                        password: loginPassword,
                        loginType: loginType.LoginType
                    }
                });
            }
            if (result.data.IsTwoFactorAuthenticationConfigured) {
                setHasMFA(true);
                document.getElementById("QRCode")?.focus();
            }
            setIsLoading(false);
        } catch (error: any) {
            if (isArray(error)) {
                let Errors: string[] = error;
                Errors.forEach((error: string) => {
                    toast.error(error);
                });
            }
            console.log(error);
            setIsLoading(false);
        }

    };

    const coreLogin = async (username: string, password: string) => {
        setIsLoading(true);
        try {
            const result = await Auth.login(username, password);
            setCoreToken(result.data.token);
            history.push('/home');
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }
    
    const resetAllData = () => {
        resetScorecard();
        resetScorecardData();
        resetScorecardType();
        resetVerificationCompany();
        resetWSPScorecard();
        resetClientRegistration();
        resetOrganisation();
        resetBBBEEScorecard();
        resetUser();
        localStorage.removeItem('coreToken');
        localStorage.removeItem('accessToken');
        setToken('');
        setCoreToken('');
    }

    const handleShowPassword = () => {
        setIsPasswordVisible(!isPasswordVisible);
    }
    
    // This was added to prevent users from manually removing with outdated cookies from their browser  
    const removeOldCookie = async () => {
        try {
            await Auth.RemoveOldCookie();
        }
        catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        removeOldCookie();
    }, []);



    if (pageLoading) {
        return <IntermediateGlobalLoading />
    }
    return (
        <PageLayout>
            <div className="Customlayer">
                <div className="Custombottom-grid">
                    <div className="Customlogo">
                        <h1>
                            <a href="/"><img src="https://app.bee123.co.za/Content/images/BEE_Logo_slogann.png" width="144px" height="57px"></img></a>
                        </h1>
                    </div>
                    <div className="links">
                        <ul className="Customlinks-unordered-list Customul">
                            <li className="active Customli">
                                <a href="/#security" className="">Security</a>
                            </li>
                            <li className="Customli">
                                <a href="/Content/StaticFiles/BEE123_Terms_and_Conditions_2023.pdf" className="">T&Cs</a>
                            </li>
                            <li className="Customli">
                                <a href="https://www.bee123.co.za/about/" target="_blank">About Us</a>
                            </li>
                            <li className="Customli">
                                <a href="https://www.bee123.co.za/contact/" target="_blank">Contact Us</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="Customcontent-w3ls">
                    <div className="Customtext-center Customicon">
                        <h1 className="CustomheadingTitle">Client Login</h1>
                    </div>
                    <div className="Customcontent-bottom">
                        {!hasMFA &&
                            <Grid item xs={12} sm={8} md={5}>
                                <LoginTextField
                                    error={loginEmailState === 'error'}
                                    placeholder="Username *"
                                    id="loginemail"
                                    fullWidth
                                    onChange={(event: any) => {
                                        if ((event.target.value == null)) {
                                            setloginEmailState("error");
                                        }
                                        setloginEmail(event.target.value);
                                    }}
                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                        if (e.key === "Enter") {
                                            loginClick();
                                        }
                                    }}
                                    InputProps={
                                        <InputAdornment position="start">
                                            <EmailIcon />
                                        </InputAdornment>
                                    }
                                />
                                {isUser ?
                                    <>
                                        <Grid container mt={2}>
                                            <LoginTextField
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" style={{ cursor: 'pointer' }}>
                                                            <span onClick={handleShowPassword}>{isPasswordVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}</span>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                error={loginPasswordState === 'error'}
                                                placeholder="Password *"
                                                id="loginpassword"
                                                fullWidth
                                                onChange={(event: any) => {
                                                    if (event.target.value == null) {
                                                        setloginPasswordState("error");
                                                    }
                                                    setloginPassword(event.target.value);
                                                }}
                                                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                                    if (e.key === "Enter") {
                                                        loginwithPasswordClick();
                                                    }
                                                }}
                                                type={isPasswordVisible ? "text" : "password"}
                                            />
                                        </Grid>
                                        <Grid item xs sx={{ textAlign: 'center' }}>
                                            <Link href={hrefLink} sx={{ color: 'white !important' }} variant="body2" onClick={() => setShowModal({ name: 'ForgotPassword', open: true })}>
                                                Forgot Password?
                                            </Link>
                                        </Grid>
                                        <Dialog open={showModal.name === 'ForgotPassword' && showModal.open} onClose={() => setShowModal({ name: '', open: false })} aria-labelledby="form-dialog-title" fullWidth>
                                            <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowModal({ name: '', open: false })}>
                                                Forgot Password
                                            </CustomDialogTitle>
                                            <DialogContent>
                                                <FormControl fullWidth sx={{ m: 1 }}>
                                                    <LoginTextField
                                                        error={forgotPasswordState === 'error'}
                                                        placeholder="Username"
                                                        id="Username"
                                                        fullWidth
                                                        onChange={(event: any) => {
                                                            if ((event.target.value == null)) {
                                                                setForgotPasswordState("error");
                                                            }
                                                            setForgotPassword(event.target.value);
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <EmailIcon />
                                                                </InputAdornment>
                                                            ),

                                                        }}
                                                        variant="standard"
                                                    />
                                                </FormControl>
                                            </DialogContent>
                                            <DialogActions>
                                                <LoadingButton loading={isForgotLoading} color='primary' onClick={() => sendResetPassword()}>Reset Password</LoadingButton>
                                            </DialogActions>
                                        </Dialog>
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <LoadingButton variant="contained" size="large" loading={isLoading} color="primary" onClick={loginwithPasswordClick}>
                                                Login
                                            </LoadingButton>

                                        </Box>


                                    </>
                                    :
                                    <>
                                        <Grid item xs sx={{ textAlign: 'center' }}>
                                            <Link href={hrefLink} sx={{ color: 'white !important' }} variant="body2" onClick={() => setShowModal({ name: 'ForgotUser', open: true })}>
                                                Forgot Username?
                                            </Link>
                                        </Grid>
                                        <Dialog open={showModal.name === 'ForgotUser' && showModal.open} onClose={() => setShowModal({ name: '', open: false })} aria-labelledby="form-dialog-title" fullWidth>
                                            <CustomDialogTitle id="customized-dialog-title" onClose={() => setShowModal({ name: '', open: false })}>
                                                Forgot Username
                                            </CustomDialogTitle>
                                            <DialogContent>
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <LoginTextField
                                                        error={forgotEmailState === "error"}
                                                        placeholder="Email Address"
                                                        id="emailAddress"
                                                        fullWidth
                                                        onChange={(event: any) => {
                                                            if ((event.target.value == null)) {
                                                                setForgotEmailState("error");
                                                            }
                                                            setForgotEmail(event.target.value);
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <EmailIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </div>
                                            </DialogContent>
                                            <DialogActions>
                                                <LoadingButton loading={isForgotLoading} color='primary' onClick={() => sendUserEmail()}>Email Username</LoadingButton>
                                            </DialogActions>
                                        </Dialog>

                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <LoadingButton size="large" variant="contained" loading={isLoading} color="primary" onClick={loginClick}>
                                                Proceed
                                            </LoadingButton>
                                        </Box>

                                    </>
                                }
                            </Grid>
                        }
                        {hasMFA &&
                            <>
                                <Grid item xs={12} sm={8} md={5}>
                                    <LoginTextField
                                        error={MFAState === "error"}
                                        placeholder="Code"
                                        id="QRCode"
                                        fullWidth
                                        onChange={
                                            (event: any) => {
                                                if ((event.target.value == null)) {
                                                    setMFAState("error");
                                                }
                                                setMFA(event.target.value);
                                            }
                                        }
                                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                            if (e.key === "Enter") {
                                                loginwithQR();
                                            }
                                        }}
                                        InputProps={
                                            <InputAdornment position="start">
                                                <Icon>
                                                    qr_code
                                                </Icon>
                                            </InputAdornment>
                                        }
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={rememberMe}
                                                onChange={(event) =>
                                                    setRememberMe(event.target.checked)
                                                }
                                                value="rememberMe"
                                            />
                                        }
                                        label="Remember Me?"
                                    />
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <LoadingButton variant="contained" size="large" loading={isLoading} color="primary" onClick={loginwithQR}>
                                            Submit
                                        </LoadingButton>
                                    </Box>
                                </Grid>
                            </>
                        }
                    </div>
                </div>

                <div className="Customtext-center" style={{ color: '#FFF' }}>
                    Send us an <a className="login-page-link" title="Email support@bee123.co.za"
                        href="mailto:sales@bee123.co.za?subject=Support Query&amp;">email</a> if you are
                    new to BEE123 and need to setup an account.
                    <br /> By logging in, you agree to the <i>
                        <a className="login-page-link" href="/Content/StaticFiles/BEE123_Terms_and_Conditions_2023.pdf"
                            target="_blank">terms & conditions</a>
                    </i> of this site.
                </div>
            </div>
        </PageLayout>
    )

}


